import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Gate debug logging behind NODE_ENV for development use only
const debugLog = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

debugLog('[DEBUG ProtectedRoute] Component loaded');

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();

  debugLog('[DEBUG ProtectedRoute] Render state:', { isAuthenticated, loading, path: location.pathname });

  // Show loading state while checking authentication
  if (loading) {
    debugLog('[DEBUG ProtectedRoute] Checking authentication...');
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Loading...</p>
      </div>
    );
  }

  // If not authenticated, redirect to the login page
  if (!isAuthenticated) {
    debugLog('[DEBUG ProtectedRoute] User not authenticated, redirecting to login');
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  // If authenticated, render the children components
  debugLog('[DEBUG ProtectedRoute] User authenticated, rendering protected content');
  return <>{children}</>;
};

export default ProtectedRoute;